import { Constants } from '@pwc/pwc-deals-web-common';
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  modal: {
    show: false,
    modalErrorType: Constants.ModalErrorType.NONE,
  },
  moreMenu: {
    itemId: null,
    show: false,
    moreMenuErrorType: Constants.MoreMenuErrorType.NONE,
  },
  banner: {
    show: false,
    message: '',
  },
  global: {},
};

const errorsSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    showModalError: (state, action) => ({
      ...state,
      modal: {
        show: true,
        modalErrorType: action.payload,
      },
    }),
    hideModalError: (state) => ({ ...state, modal: initialState.modal }),
    showMoreMenuError: (state, action) => ({
      ...state,
      moreMenu: {
        show: true,
        itemId: action.payload.itemId,
        moreMenuErrorType: action.payload.moreMenuErrorType,
      },
    }),
    hideMoreMenuError: (state) => ({
      ...state,
      moreMenu: initialState.moreMenu,
    }),

    showBannerError: (state, action) => ({
      ...state,
      banner: {
        show: true,
        message: action.payload,
      },
    }),
    hideBannerError: (state) => ({ ...state, banner: initialState.banner }),
    showGlobalError: (state, action) => ({
      ...state,
      global: {
        ...state.global,
        ...action.payload,
      },
    }),
    hideGlobalError: (state) => ({ ...state, global: initialState.global }),
  },
});

// Actions
export const {
  showModalError,
  hideModalError,
  showMoreMenuError,
  hideMoreMenuError,
  showBannerError,
  hideBannerError,
  showGlobalError,
  hideGlobalError,
} = errorsSlice.actions;

// Selectors
export const getErrorModalState = (state) => state.errors.modal;
export const getErrorMoreMenuState = (state) => state.errors.moreMenu;
export const getErrorBannerState = (state) => state.errors.banner;
export const getGlobalErrorState = (state) => state.errors.global;

export default errorsSlice.reducer;
